import { BaseRepository } from './BaseRepository'

/**
 * AddonsRepository — re-implementacion limpia (SQL) de los addons de occurrence de v1
 * (REFERENCIA — NO importado). Tabla `addons`, entity `occurrence`, pk `client_uuid`.
 *
 * Los addons viajan en la sync de la occurrence: cada addon es un valor latest-state
 * por su propio client_uuid -> coalesce. No requiere lectura previa, asi que usa el
 * camino publico saveOptimistic con coalesce:true. body NORMALIZADO (fila del addon).
 */
export class AddonsRepository extends BaseRepository {
  constructor () {
    super('addons', 'occurrence', 'client_uuid')
  }

  /**
   * Guarda/actualiza un addon (latest-state, coalesce por client_uuid del addon).
   * @param {object} addonRow  fila del addon (incluye client_uuid).
   * @returns {Promise<string>} client_uuid.
   */
  async saveAddon (addonRow = {}) {
    const uuid = addonRow.client_uuid
    return this.saveOptimistic({
      clientUuid: uuid,
      dataRow: { ...addonRow },
      op: 'occurrence.syncOccurrence',
      coalesce: true,
      body: { occurrence_id: addonRow.occurrence_id }
    })
  }
}

export const addonsRepository = new AddonsRepository()
